<template>
  <AppBarLayout>
    <template #default>
      <div class="main tw-flex tw-justify-center tw-bg-[#E4F1FF]">
        <BrandPattern4 page="LANDING" class="tw-bg-[#E4F1FF] !tw-top-0" />
        <div
          id="click-box"
          class="tw-relative tw-w-[36vw] tw-h-full tw-flex-col tw-flex tw-justify-center tw-items-center"
        >
          <div
            class="tw-flex tw-items-center tw-flex-col tw-gap-[20px] tw-px-[112px]"
          >
            <CyberSystemIcon class="tw-mb-[10px]" />
            <span
              class="tw-text-[#211F58] tw-text-[25px] tw-not-italic tw-font-semibold tw-leading-[100%]"
            >
              {{ getComponentUiText("user-temp-holding-heading-1") }}
            </span>
            <span
              class="tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[150%] tw-text-center"
            >
              {{ getComponentUiText("app-landing-heading-sub-1") }}
            </span>
          </div>
          <div
            class="tw-flex tw-flex-col tw-gap-[5px] tw-bg-[#FFFFFF] tw-rounded-md tw-mt-[40px] tw-p-[25px]"
          >
            <span
              class="tw-text-[#211F58] tw-text-[20px] tw-not-italic tw-font-semibold tw-leading-[130%]"
              >{{ getComponentUiText("app-landing-risk-dashboard-title-1") }}
            </span>
            <span
              class="tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[130%]"
              >{{ getComponentUiText("app-landing-risk-dashboard-info-1") }}
            </span>
          </div>
          <b-button
            variant="primary"
            class="button-verify tw-bg-[#387DFF] tw-mt-[40px] tw-w-fit tw-py-[11px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
            @click="onNavigateToDashboard"
          >
            {{ getComponentUiText("app-landing-button-return-1") }}
          </b-button>
        </div>
      </div>
    </template>
  </AppBarLayout>
</template>

<script lang="ts" setup>
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import BrandPattern4 from "@/components/prospect/brandPattern/brandPattern4.vue";
import CyberSystemIcon from "@/components/svgs/cyberSystemIcon.vue";
import router from "@/router";
import { getComponentUiText } from "@/utils/utilities";
import { routers } from "@/utils/constants";
import store from "@/store";
const onNavigateToDashboard = () => {
  store.dispatch("Navigation/setActiveHierarchy", [
    getComponentUiText("app-menu-home-1"), //"Home",
    getComponentUiText("app-menu-submenu-home-dashboard-1"), //"Dashboard",
  ]);
  store.dispatch("Navigation/setPrimaryMenuIndex", 0);
  router.replace(routers.dashboard);
};
</script>

<style lang="scss" scoped>
#appBarLayout {
  overflow-y: hidden;
  background: #ffffff;
}

#body {
  flex-wrap: nowrap;
}

.main {
  position: relative;
  height: 100%;
}

.headingWrapper {
  align-items: center;
  width: 100%;
}
</style>
